import { useTranslation } from 'react-i18next'
import List from 'components/configuration/components/lms-profiles/List'
import Wrapper from 'components/reusables/wrapper'
import { Title, Description } from './styled'

const LmsProfiles = () => {
  const { t } = useTranslation()
  const translationPrefix = 'configuration.lmsProfiles'

  return (
    <Wrapper shadow>
      <Title>{t(`${translationPrefix}.title`)}</Title>
      <Description>{t(`${translationPrefix}.description`)}</Description>
      <List />
    </Wrapper>
  )
}

export default LmsProfiles
